import { FilePicker, FormWrapper, PassphraseField } from '../../widgets';
import { useState } from 'react';
import { FormGroup, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import { extractText } from '@steganography-js/core';


const Extract = () => {

	const [content, setContent] = useState(null);
	const [text, setText] = useState('');
	const [pass, setPass] = useState(null);

	const onImageSelected = (content) => {
		setContent(content);
	};

	const process = async () => {
		if (content) {
			try {
				const text = await extractText(content, pass);
				setText(text);
			} catch (e) {
				alert(e);
			}
		}
	};

	return (
		<>
			<div className="page-wrapper">
				<h1>Extract Text from PNG</h1>
				<FormWrapper>
					<Form onSubmit={(e) => { e.preventDefault(); process(); }}>

						<FormGroup className="mt-1">
							<Form.Label>PNG in which the text was embedded</Form.Label>
							<FilePicker onImageSelected={onImageSelected} />
							<Form.Text className="text-muted">Select the PNG file containing the embedded message.</Form.Text>
						</FormGroup>

						<FormGroup className="mt-3">
							<Form.Label>Passphrase</Form.Label>
							<PassphraseField onChange={ (e) => setPass(e.target.value) } />
							<Form.Text className="text-muted">Passphrase used to encrypt the above message.</Form.Text>
						</FormGroup>

						<Button variant="primary" type="submit" className="mt-4">
							Extract
						</Button>

						<hr />

						<FormGroup className="mt-3">
							<Form.Control 
								as="textarea" 
								value={text} 
								placeholder="Extracted message will be shown here" 
								readOnly 
								rows={10} 
							/>
						</FormGroup>


					</Form>
				</FormWrapper>

			</div>
		</>
	);
};

export default Extract;